<!--列印拜訪聯繫函(公版)-->
<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">列印拜訪聯繫函</h3>
        </div>
        <div class="modal-body">
          <div class="warning">
            <ul>
              <li>在名單專區/服務、權益/異動後實質接觸明細項目內，查無【應實質接觸】或【未實質接觸】保戶。</li>
              <li style="color:red;">提供列印公版服務聯繫專函。</li>
              <li>拜訪聯繫函地址來源為客戶基本資料的現居地址。</li>
              <li>如有疑問，請洽總公司業務部業務企劃科，(02)27551399 #{{ this.$store.state.serviceLine }}</li>
            </ul>  
          </div>
          <div class="action text-right">
            <a @click.prevent="submit()" class="btn btn-primary">列印</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { contactLetter, showContactLetterPDF } from "../../service/index.js";
import {commonMixin} from '@/mixins/common'
export default {
  name: "ContactLetter",
  mixins: [commonMixin],
  computed: {
  },
  data() {
    return {
      isBox: false,
      zip_code: "",  //客戶郵遞區號
      payaddr: "",   //客戶地址
      csidno: "",    //客戶ID
      ceapcnm: "",   //客戶姓名
      agidno: "",    //業務員ID
      agnt_name: "", //業務員姓名
      cedvnm4: "",   //通訊處
      addr: "",      //通訊處地址
      mgr_name: "",  //主管姓名
      phone_01: "",  //通訊處電話
    };
  },
  watch: {
    open (val) {
      if (val) {
        this.init() // 初始化
      }
    },
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    custAddress: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  methods: {
    init() {
      this.isBox = this.$store.state.userInfo.userType ==='box';
      this.agidno = this.formData.agidno;
      this.agnt_name = this.formData.agnt_name;
      this.cedvno = this.formData.cedvno;
      this.csidno = this.formData.csidno;
      this.ceapcnm = this.formData.cs_name;
      // this.zip_code = this.formData.iaa_zip;
      // this.payaddr = this.formData.iaa_addr;
      this.zip_code = this.custAddress[0];
      this.payaddr = this.custAddress[1].trim() + this.custAddress[2].trim() + this.custAddress[3].trim();
    },
    async submit() {
      let newWindow;
      if (!this.isBox) {
        newWindow = window.open("/crm/assets/common/ajax-loader.gif");
      };
      //如果IAA沒資料的話，才去查異動後實質接觸明細裡的資料
      if(!this.payaddr) {
        //查詢客戶資訊
        await contactLetter("9", this.agidno, this.csidno, this.cedvno).then((result) => {
          if (result && result.header.status == "200" && result.body) {
            let data = result.body.cust_info;
            if (data[0]) {
              this.zip_code = data[0].cs_zip;
              this.payaddr = data[0].cs_addr;
            }
          }
        });
      }
      //查詢單位資訊
      await contactLetter("10", this.agidno, this.csidno, this.cedvno).then((result) => {
        if (result && result.header.status == "200" && result.body) {
          let data = result.body.div_info;
          if (data[0]) {
            this.mgr_name = data[0].mgr_name;
            this.addr = data[0].addr;
            this.phone_01 = data[0].phone_01;
            this.cedvnm4 = data[0].cedvnm4;
          }
        }
      });

      const param = {
        zip_code: this.zip_code,
        payaddr: this.payaddr, 
        ceapcnm: this.ceapcnm,
        agnt_name: this.agnt_name,
        cedvnm4: this.cedvnm4,
        addr: this.addr,
        mgr_name: this.mgr_name,
        phone_01: this.phone_01,
      };
      //公版聯繫函-列印
      const pdfResult = await showContactLetterPDF(
        this.agidno,
        param
      );
      if (this.isBox) {
        this.boxSendBase64PdfData(new Uint8Array(pdfResult.file));
      } else {  
        const file = new Blob([new Uint8Array(pdfResult.file)], {
          type: "application/pdf"
        });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, "post.pdf");
        } else {
          newWindow.location = URL.createObjectURL(file);
        }
      };
    }
  },
};
</script>
